export enum DateRange {
  TODAY = "today",
  CURRENT_MONTH = "currentMonth",
  CURRENT_YEAR = "currentYear",
  YEAR = "year",
}
